export const Logo = ({ size = 34 }) => (
  <img
    src="/logo-full.png"
    alt="Jwellary — Imitation Fine Jewellery"
    style={{ height: Math.round(size * 1.25), width: "auto" }}
    className="select-none"
    draggable={false}
  />
);

export default Logo;
